<template>
  <v-flex data-qa="mortgage-flex-85lzem">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2" data-qa="mortgage-layout-qst16m">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="mortgage-flex-tea4fsj">
        <v-container class="pa-6 pl-8" data-qa="mortgage-container-i8mnhr">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="mortgage-flex-vvsqzv">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="mortgage-flex-4fklqq">
              <v-row no-gutters class="pb-2" data-qa="mortgage-row-u77sog">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                  <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                    {{ $t("common.mortgageAgreementLabel") }} <font v-if="showTotalAccountsAvailable">({{mortgageAccount.accounts.length}})</font>
                  </font>
              </v-row>
            </v-flex>
            <v-row class="pt-4 pl-4" data-qa="mortgage-row-9oamf">
              <v-layout data-qa="mortgage-layout-93do1n">
                <v-flex class="px-1" data-qa="mortgage-flex-zor2gp">
                  <font class="subheading-1 font-weight-medium white--text"
                  >{{ $t("homeCards.mortgageNumber") }}
                  </font>
                  <br data-qa="mortgage-br-xnh0or"  />
                  <font class="text-h5 font-weight-bold white--text">
                    {{ mortgageID }}</font
                  >
                </v-flex>
                <v-flex class="px-1" data-qa="mortgage-flex-byiss">
                  <font class="subheading font-weight-medium white--text">{{
                    $t("mortgage.amount")
                  }}</font>
                  <br data-qa="mortgage-br-ll2ll"  />
                  <font class="text-h5 font-weight-bold white--text"
                    >{{ $formatter.currency.format(accDetails.amount, accDetails.currency) }}
                  </font>
                </v-flex>
                <v-flex class="px-1" data-qa="mortgage-flex-ckqr1m">
                  <font class="subheading font-weight-medium white--text">{{
                    $t("mortgage.outstandingAmount")
                  }}</font>
                  <br data-qa="mortgage-br-qdwgcp"  />
                  <font class="text-h5 font-weight-bold white--text"
                    >{{
                      $formatter.currency.format(accDetails.amount, accDetails.currency)
                    }}
                  </font>
                </v-flex>
                <v-flex class="text-end" data-qa="mortgage-flex-82iox2">
                  <v-btn
                    v-if="showGenerateQuotesOption"
                    @click="goToGeneratedQuote()"
                    color="white"
                    class="text-none py-2 px-4"
                    small
                    outlined
                   data-qa="mortgage-btn-2gk4bb">{{ $t("redemptionQuoteLabels.generatedQuoteBtn") }}</v-btn>
                </v-flex>
                <v-flex data-qa="mortgage-flex-hrq9y">
                  <v-btn
                    v-if="showRedemptionQuoteOption"
                    @click="goToRedemptionHome()"
                    color="white"
                    class="text-none py-2 px-4"
                    small
                    outlined
                   data-qa="mortgage-btn-rnwk62">{{ $t("redemptionQuoteLabels.label") }}</v-btn>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex
    class="pt-2 ml-2" xs12 sm12 md12 lg12 xl12
    v-if="mortgageAddress && !showGeneratedQuotes"
     data-qa="mortgage-flex-bgugd2q">
      <span data-qa="mortgage-span-dtbpm">
        <v-alert
          class="pa-1"
          outlined
          text elevation="2"
          color="#694ED6"
          transition="scale-transition" data-qa="mortgage-alert-xcbq7">
            <v-row no-gutters class="pb-2" data-qa="mortgage-row-1ai9a">
                  <inline-svg
                  class="mt-3 pl-1"
                  :src="getMortgageAddIcon()"
                  width="21"
                  height="17.85"
                  aria-label="Navigation Icon"
                  ></inline-svg>
                  <font
                  class="subtitle-2 font-weight-bold mt-3 pl-2"
                  color="black">
                    {{ $t("mortgage.mortgageAddress") }}</font
                  >
            </v-row>
            <v-row no-gutters data-qa="mortgage-row-er329k">
              <v-layout row wrap data-qa="mortgage-layout-irzh6">
                <v-flex class="px-1" data-qa="mortgage-flex-z6n8ym">
                  <v-layout wrap data-qa="mortgage-layout-9tby2">
                    <v-flex class="pl-4 pb-5" data-qa="mortgage-flex-vu28qs">
                      <font class="Body-2 font-weight-bold black--text">
                        {{ this.mortgageAddress }}</font
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-row>
        </v-alert>
      </span>
    </v-flex>
    <v-flex v-if="!showGeneratedQuotes" xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="mortgage-flex-vqld5a">
      <CardLayout :config="mortgageAccount" />
    </v-flex>
    <!-- Generated Quotes Screen -->
    <v-container v-if="showGeneratedQuotes" data-qa="mortgage-container-931y5">
      <!-- List the Generated Quotes -->
      <v-list v-if="generatedQuoteList.length" class="px-5" data-qa="mortgage-list-3p9kba">
        <v-list-item-content
          v-for="(quote, index) in generatedQuoteList"
          :key="index"
          :data-qa="`mortgage-list-item-content-bnu5v-${index}`">
          <v-card-text class="pa-2" :data-qa="`mortgage-card-text-zez5km-${index}`">
            <v-layout wrap :data-qa="`mortgage-layout-c94lll-${index}`">
              <v-flex xs12 sm12 md12 lg7 xl7 :data-qa="`mortgage-flex-o9hmun-${index}`">
                <span
                  class="body-1 font-weight-regular"
                  v-text="quote.data"
                  :data-qa="`mortgage-span-5n1u0v-${index}`"></span>
              </v-flex>
              <v-flex xs12 sm12 md12 lg5 xl5 :data-qa="`mortgage-flex-t3aj5-${index}`">
                <v-btn
                  @click="downloadQuote('view', quote.documentId)"
                  text
                  :color="primaryColor"
                  :data-qa="`mortgage-btn-ckdqif-${index}`">
                  <v-icon left size="18px" class="material-symbols-outlined" :data-qa="`mortgage-icon-om11pt-${index}`">visibility</v-icon>
                  <font class="body-2 font-weight-regular">
                  {{
                    $t("consolidatedStatement.viewBtn")
                  }}</font>
                </v-btn>
                <v-btn
                  @click="downloadQuote('download', quote.documentId, quote.data)"
                  text
                  :color="primaryColor"
                  :data-qa="`mortgage-btn-3rnd7m-${index}`">
                  <v-icon left size="18px" class="material-symbols-outlined" :data-qa="`mortgage-icon-0cr4w-${index}`">download</v-icon>
                  <font class="body-2 font-weight-regular">{{
                    $t("consolidatedStatement.downloadBtn")
                  }}</font>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-divider :data-qa="`mortgage-divider-iufl3n-${index}`"  v-if="!(index === generatedQuoteList.length - 1)" />
        </v-list-item-content>
      </v-list>
      <v-row v-if="(!generatedQuoteList.length && noQuoteAvail)" no-gutters justify="center" class="ma-6" data-qa="mortgage-row-ssio0c">
        <v-sheet outlined class="text-center pa-6" color="#FFFFFF" data-qa="mortgage-sheet-i4sw0l">
          <v-icon x-large :color="primaryColor" class="pb-3"
             data-qa="mortgage-icon-5j55zj">mdi-file-document</v-icon
          >
          <p class="ma-6 mt-0 px-12" data-qa="mortgage-p-3ucbvn">
            {{ $t("redemptionQuoteLabels.noQuotesAvailable") }}
          </p>
        </v-sheet>
      </v-row>
      <v-row no-gutters class="mt-3 mb-3" data-qa="mortgage-row-8dryymh">
        <v-col data-qa="mortgage-col-eblwe">
          <v-btn text color="primary" @click="goBack" data-qa="mortgage-btn-12a7m">
            <v-icon left class="text-capitalize" data-qa="mortgage-icon-bcc8qh">arrow_left_alt</v-icon>
            {{ $t("common.goBack") }}
          </v-btn>
        </v-col>
        <v-spacer data-qa="mortgage-spacer-ht3zcw"  />
        <v-col v-if="mortgageID" data-qa="mortgage-col-hbdid1h">
          <v-btn text :color="primaryColor" @click="goToMortgageAccountsDisplay" data-qa="mortgage-btn-lpxxhf">
            {{ $t("mortgage.viewAcc") }}
          </v-btn>
        </v-col>
      </v-row>
      <!-- Doc preview -->
      <PDFPreview v-if="viewPDF" :PDFData="PDFData" @closePdfPreview="viewPDF= false"/>
    </v-container>
  </v-flex>
</template>

<script>
import event from '@/util/event'
import preload from '@/util/preload'
import store from '@/core/store'
import CardLayout from '@/views/home/HomeCards.vue'
import commonService from '@/service/commonService.js'
import Loader from '../../components/common/Loader.vue'
import PDFPreview from '@/components/common/PDFPreview.vue'

export default {
  name: 'Mortgage',
  components: {
    Loader,
    CardLayout,
    PDFPreview
  },
  data () {
    return {
      loaderEnabled: false,
      mortgageID: '',
      customerId: '',
      mortgageAddress: '',
      mortgageAccount: {
        title: this.$t('common.loanLabel'),
        cardLabels: false,
        openNewACCard: false,
        accounts: []
      },
      accDetails: {
        amount: 0,
        outstandingAmount: 0,
        series: []
      },
      generatedQuoteList: [],
      noQuoteAvail: true,
      showGeneratedQuotes: false,
      viewPDF: false,
      PDFData: undefined,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableMortgageSection,
      longestMaturityDate: '',
      showRedemptionQuoteOption: this.$appSettings.defaultConfigurations.loanScreen.redemptionQuote.enableRedemptionQuoteOption,
      showGenerateQuotesOption: this.$appSettings.defaultConfigurations.loanScreen.showGeneratedQuotesTab
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  async created () {
    this.isSmeLogin = JSON.parse(sessionStorage.getItem('isSmeLogin'))
    this.setAccountId()
    event.$on('set_myMortgageAccounts', () => {
      this.getListOfLoanAccounts()
      this.loaderEnabled = false
    })
    this.mortgageID = this.$route.params.mortgageID
      ? this.$route.params.mortgageID
      : ''
    if (this.mortgageID) {
      this.getListOfLoanAccounts()
      await this.getListOfQuotes()
    } else this.$router.push({ name: 'Home' })
    if (this.ifMyAccountsAvailable()) {
      this.getListOfLoanAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfLoanAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    getMortgageAddIcon () {
      return this.getSvgIconSrc('loanAddress')
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].mortgageAccounts
    },
    async getListOfLoanAccounts () {
      this.loaderEnabled = true
      let response = {}
      if (this.mortgageID) {
        response = await commonService.getMortgageAccountDetails(
          this.mortgageID)
      }
      if (response && response.items) {
        this.setLoanAccounts(response.items)
      }
      this.loaderEnabled = false
    },
    setLoanAccounts (mortgageAccount) {
      this.mortgageAccount.accounts = mortgageAccount
      this.accDetails.currency = mortgageAccount[0]?.loanAmount?.currency
      this.accDetails.amount = 0
      this.accDetails.outstandingAmount = 0
      this.getLongestMaturityDate(mortgageAccount)
      for (const i in mortgageAccount) {
        this.accDetails.amount += mortgageAccount[i].loanAmount.amount
        this.accDetails.outstandingAmount +=
          mortgageAccount[i].loanOutstandingAmount.amount
      }
    },
    setAccountId () {
      if (this.isSmeLogin) {
        const corporateId = JSON.parse(sessionStorage.getItem('corporateId'))
        this.getMortgageAddress(corporateId)
      } else {
        const partyID = JSON.parse(sessionStorage.getItem('username'))
        this.getMortgageAddress(partyID)
      }
    },
    async getMortgageAddress (accountId) {
      const data = accountId
      const response = await commonService.getMortgageAddressDetails(data)
      if (response && response.items) {
        for (const i of response.items) {
          if (i.loanAgreementId === this.mortgageID) {
            this.mortgageAddress = i.loanAgreementDescription
          }
        }
      } else {
        this.mortgageAddress = false
      }
    },
    goToRedemptionHome () {
      this.$router.push({
        name: 'RedemptionQuote',
        params: { loanId: '', mortgageID: this.mortgageID, maturityDate: this.longestMaturityDate }
      })
    },
    goToGeneratedQuote () {
      this.showGeneratedQuotes = true
    },
    async getListOfQuotes () {
      const details = {
        businessType: 'LOAN-AGREEMENT',
        businessValue: this.mortgageID,
        docType: 'LOAN-REDEMPTION-QUOTE',
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      const response = await commonService.getListOfAccDocStatements(details)
      if (response && response.items) {
        this.noQuoteAvail = false
        this.generatedQuoteList = []
        response.items.forEach((item) => {
          // const fromDate = item.fromDate ? this.$formatter.formatDate(item.fromDate) : ''
          // const toDate = item.toDate ? this.$formatter.formatDate(item.toDate) : ''
          this.generatedQuoteList.push({
            data: item.generationDate,
            documentId: item.documentId
          })
        })
      } else {
        this.generatedQuoteList = []
        this.noQuoteAvail = true
      }
      // this.loaderEnabled = false
    },
    async downloadQuote (type, documentId, generationDate) {
      const body = {
        businessType: 'LOAN-AGREEMENT',
        businessValue: this.mortgageID,
        docType: 'LOAN-REDEMPTION-QUOTE'
      }
      const response = await commonService.downloadStatement(documentId, body)

      if (response && !response.causes) {
        const timestamp = '00-00-00' // As timestamp isn't available in response API
        const fileName = `LEN_MortgageRedemptionQuote_QUOTE7831_${generationDate}_${timestamp}.pdf`
        // const blobObject = new Blob([response], { type: 'application/pdf' })
        // const fileURL = window.URL.createObjectURL(blobObject)
        if (type === 'view') {
          this.PDFData = response
          this.viewPDF = true
        } else {
          if (response && !response.causes) {
            // positive response
            // this.downloadFile(fileURL, fileName)
            var a = document.createElement('a') // Create <a data-qa="mortgage-a-2g4hpp">
            a.href = response // Image Base64 Goes here
            a.download = fileName
            a.click()
          }
        }
      }
    },
    goToMortgageAccountsDisplay () {
      this.$router.push({
        name: 'MortgageAccountListDisplay',
        params: { mortgageID: this.mortgageID }
      })
    },
    goBack () {
      this.showGeneratedQuotes = false
    },
    getLongestMaturityDate (items) {
      const longestItem = items?.reduce((max, item) => {
        return new Date(item.maturityDate) > new Date(max.maturityDate) ? item : max
      })
      this.longestMaturityDate = longestItem.maturityDate
    }
  },
  beforeDestroy () {
    event.$off('set_myMortgageAccounts')
  }
}
</script>
